import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { OtpformComponent } from './otpform/otpform.component';
import { IndexComponent } from './index/index.component';
import { SkilldevelopmentComponent } from './skilldevelopment/skilldevelopment.component';
import { WebinarsComponent } from './webinars/webinars.component';
import { VouchersComponent } from './vouchers/vouchers.component';
import { GiftvouchersComponent } from './giftvouchers/giftvouchers.component';
import { SpecialsComponent } from './specials/specials.component';
import { MotherspageComponent } from './motherspage/motherspage.component';
import { FooterComponent } from './footer/footer.component';
import { EventsComponent } from './events/events.component';
import { DiwaliVoucherComponent } from './diwali-voucher/diwali-voucher.component';
import { AuthGuard, NoAuthGuard } from './auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'otp', pathMatch: 'full' },
  { path: 'otp', component: OtpformComponent, canActivate: [NoAuthGuard] },
  { path: 'otp/:mobile', component: OtpformComponent, canActivate: [NoAuthGuard] },
  { path: 'index', component: IndexComponent, canActivate: [AuthGuard] },
  // { path: 'category/:categoryId', component: CategoryComponent },
  { path: 'category/:categoryId', component: SkilldevelopmentComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: WebinarsComponent, canActivate: [AuthGuard] },
  { path: 'vouchers/:categoryId', component: VouchersComponent, canActivate: [AuthGuard] },
  { path: 'giftvoucher', component: GiftvouchersComponent, canActivate: [AuthGuard] },
  { path: 'specials', component: SpecialsComponent, canActivate: [AuthGuard] },
  { path: 'events/:event_code', component: MotherspageComponent, canActivate: [AuthGuard] },
  { path: 'event/:event_code', component: GiftvouchersComponent, canActivate: [AuthGuard] },
  { path: 'diwali', component: DiwaliVoucherComponent, canActivate: [AuthGuard] },
  { path: 'diwali/category/:categoryId', component: DiwaliVoucherComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: 'otp' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
